import FeatureDescription from './FeatureDescription';
export default function FeatureType ( props ) {
  let feature_type;
  switch ( (props.feature.feature_type).toString() ) {
  case '1':
  case '2':
    feature_type =
                <p>
                  <FeatureDescription
                    description={props.feature.feature_description}
                    extra_description={props.feature.feature_extra_description}
                    value={props.feature.feature_value}
                    title={props.feature.feature_title}
                  />
                </p>
    ;
    break;
  case '5':
  case '6':
    feature_type =
                <p>
                  <FeatureDescription
                    description={props.feature.feature_description}
                    extra_description={props.feature.feature_extra_description}
                    icon_info={true}
                    title={props.feature.feature_title}
                  />
                </p>
    ;
    break;
  case '7':
  case '8':
    feature_type =
                <p>
                  <FeatureDescription
                    description={props.feature.feature_description}
                    extra_description={props.feature.feature_extra_description}
                    options={props.feature.feature_options}
                    title={props.feature.feature_title}
                  />
                </p>
    ;
    break;
  }

  return feature_type;
}
